import { LoadingPlaceholder } from "designSystem/index";
import React from "react";

export default () => (
	<LoadingPlaceholder
		subtitleProps={{ res: "Loading subtitle" }}
		titleProps={{ res: "Loading title" }}
	/>
);
